import './about.scss';

import { Breadcrumbs } from '../../components/layout';
import { People } from '../../components/sections/people/People';
import { Services } from '../../components/sections/services/Services';
import { people } from '../../content';

const breadcrumbs = [
  {
    name: 'About us',
    isActive: true,
  },
];

export const About = () => {
  return (
    <>
      <section className="container position-relative about-hero">
        <div
          className="position-absolute top-0 start-0 w-100 bg-position-bottom-center bg-size-cover bg-repeat-0"
          style={{ backgroundImage: 'url(/assets/img/about/hero-bg.svg)' }}
        >
          <div className="d-lg-none" style={{ height: '960px' }}></div>
          <div className="d-none d-lg-block" style={{ height: '768px' }}></div>
        </div>

        <div className="position-relative">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className="row">
            <div className="col-lg-6">
              <h1 className="pb-2 pb-md-3 about-title">About Ounic</h1>
              <p className="pb-4 mb-1 mb-md-2 mb-lg-3 about-text">
              We are a skilled team dedicated to helping startups and established companies launch effective software 
              solutions that drive growth, improve user experiences, and create meaningful impact in the digital world.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="bg-secondary page-section">
        <Services />
      </div>

      <section className="container page-section">
        <h2 className="h1 text-center about-section-title">Our People</h2>
        <People people={people} />
      </section>
    </>
  );
};
